<template>
    <div>
        <CardWithImageAndButton
        title="Начните работать со статистикой"
        text="
        Специализированный сервис сбора и анализа статистики посещаемости веб-сайтов, созданный в соответствии с требованиями 171 Указа Президента РФ.
        <br /><br />
        Благодаря встроенному модулю обогащения данных, платформа позволяет более глубоко понимать поведение аудитории, выявлять тренды, оценивать эффективность контента и навигации.
        <br /><br />
        Аналитика доступна как в виде преднастроенных отчётов, так и через гибкий конструктор, позволяющий формировать кастомные срезы по десяткам параметров.
        <br /><br />
        Используемые технологии: Go, JavaScript, Postgres, Redis.
        "
        :imagePath="require('../../assets/imgs/analytics.png')"
        />

        <TextBlockWithHeader
        title=""
        text="Устанавливая аналитическую систему в исполнение Указа Президента РФ от 17.04.2017 № 171, органы государственной власти используют счётчик обращения граждан информационной системы «Мониторинга и анализа обращений граждан». Данная информационная система относится к зоне ответственности ПАО «Ростелеком»."
        theme="dark"
        />

        <TextBlockWithHeader
        title=""
        text="Российский сервис веб-статистики, который помогает получать статистические данные о посетителях интернет-ресурсов, их вовлечённости, источниках переходов и точках входа на сайт, поисковых запросах, популярных страницах и другие отчёты. <br /><br />Платформа позволяет сложным структурам с разным уровнем подчинения иметь полную и подробную аналитику о пользователях сайтов и онлайн-сервисов, включая закрытые системы и сервисы, которые оперируют персональными данными пользователей или непубличной информацией."
        />

        <NumberedList
        title="На службе государства и бизнеса"
        text=""
        :items=numberedListItems
        theme="dark"
        />
    </div>
</template>

<script>
    import { TextBlockWithHeader, CardWithImageAndButton, NumberedList } from 'sputnik-ui/src/index';

    export default {
        name: 'AnalyticsPage',
        components: {
            TextBlockWithHeader,
            CardWithImageAndButton,
            NumberedList
        },
        data() {
            return {
                numberedListItems: [
                {title: "Сегментация", text: "Возможность сегментировать аудиторию, выделив для анализа среди всех пользователей ресурса только пользователей с заданными параметрами."},
                {title: "Безопасность", text: "Собранные данные обрабатываются и хранятся на территории РФ в технической инфраструктуре национального оператора связи «Ростелеком» и не используются какими-либо внутренними или сторонними сервисами аналитики или для таргетирования интернет-рекламы."},
                {title: "Гибкость", text: "Сбор данных о посетителях сайтов и их действиях можно дополнить сведениями, например, о местонахождении пользователей. Учет действий ведется как для авторизованных, так и анонимных посетителей."},
                {title: "Простота", text: "Возможность установки единого счётчика для группы сайтов. Для всех сайтов формируется единый код, что упрощает процесс установки: код можно просто разослать по почте, даже если речь идёт о сотне сайтов с разными администраторами."},
                ],
            };
        },
    }
</script>

<style lang="scss" scoped>
    .wrapper {
        padding-top: 50px;
        padding-bottom: 50px;
    }

</style>
